import { getUserInfo } from 'meinian-package/src/common/userInfo'
import { isPermissions } from 'meinian-package/src/utils/auth'

export const hasAnnotationAuth = (auth, userId) => {
  const userInfo = getUserInfo()
  return isPermissions(auth, ['FS10', 'FS10_CREATOR']) || userInfo.userId === userId
}

export const hasCommentAuth = (auth, userId) => {
  const userInfo = getUserInfo()
  return isPermissions(auth, ['FS10', 'FS10_CREATOR']) || userInfo.userId === userId
}
